var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { isFSA } from 'flux-standard-action';
import { HTTP_STATUS } from './constants';
// @ts-ignore
var isPromise = function (val) { return val && typeof val.then === 'function'; };
var HTTP_STATUS_WITH_NO_ERROR_LIST = [
    HTTP_STATUS.TOO_MANY_REQUEST,
    HTTP_STATUS.LOOP_DETECTED,
];
// @ts-ignore
export default (function (_a) {
    var dispatch = _a.dispatch;
    return function (next) { return function (action) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, response, response_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!!isFSA(action)) return [3 /*break*/, 3];
                    if (!isPromise(action)) return [3 /*break*/, 2];
                    _a = dispatch;
                    return [4 /*yield*/, action];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
                case 2: return [2 /*return*/, next(action)];
                case 3:
                    if (!isPromise(action.payload)) {
                        return [2 /*return*/, next(action)];
                    }
                    //   dispatch(showLoading(action.type))
                    if (!action.payload) {
                        return [2 /*return*/];
                    }
                    _b.label = 4;
                case 4:
                    _b.trys.push([4, 6, , 7]);
                    return [4 /*yield*/, action.payload
                        // dispatch(hideLoading(action.type, processConfirmationGuard))
                    ];
                case 5:
                    response = _b.sent();
                    // dispatch(hideLoading(action.type, processConfirmationGuard))
                    return [2 /*return*/, dispatch(__assign(__assign({}, action), { payload: response, error: false }))];
                case 6:
                    response_1 = _b.sent();
                    return [2 /*return*/, dispatch(__assign(__assign({}, action), { 
                            // @ts-ignore
                            payload: HTTP_STATUS_WITH_NO_ERROR_LIST.includes(response_1.error.status)
                                ? {}
                                // @ts-ignore
                                : response_1.error, error: true }))];
                case 7: return [2 /*return*/];
            }
        });
    }); }; };
});
